module.exports = __webpack_public_path__ + "static/media/true_shots.99d3b2d6.png";